import { HttpContextToken } from '@angular/common/http';

export const ACCESS_TOKEN = 'ACCESS_TOKEN';

export const JWT_TENANT_ID_CLAIM = 'TenantId';
export const JWT_ENTITY_ID_CLAIM = 'EntityId';
export const JWT_PAGE_TYPE_CLAIM = 'PageType';
export const JWT_SHORT_CODE_CLAIM = 'ShortCode';

/**
 * HttpContext token to indicate whether to clear tokens after response
 * Default: false (tokens are preserved)
 * To clear tokens: httpClient.post(url, data, { context: new HttpContext().set(CLEAR_TOKENS_ON_RESPONSE, true) })
 */
export const CLEAR_TOKENS_ON_RESPONSE = new HttpContextToken<boolean>(() => false);

/**
 * HttpContext token to skip authentication for external API calls
 * Default: false (authentication is applied)
 * To skip auth: httpClient.post(url, data, { context: new HttpContext().set(SKIP_AUTH, true) })
 *
 * Use this for third-party API calls (e.g., PayPal, Stripe) that use their own authentication
 */
export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);
